module.exports = "https://cdn.dove.it/_next/static/public/assets/immobiliare-certificate-2025.770d171a4bc2606dfac3162017e2910e.png";